import { SyncManager } from 'db';
import { useField } from 'react-final-form';
import { useFormVehicleId } from './useFormVehicleId';

export const useSaveGrade = (sectionId: string) => {
  const vehicleId = useFormVehicleId();

  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const save = async (grade: string) => {
    const syncManager = SyncManager.getInstance(vehicleId);
    if (!syncManager) return;

    await syncManager.queueEntityUpdate(serverId, 'section', ['grade', grade]);
  };

  return save;
};
